<template>
    <div class="get-email">
        <h2 class="get-email--heading">{{ $t('REGISTER_YOUR_EMAIL')}}</h2>
        <input
            id="email-address"
            name="email"
            autocomplete="email"
            autocapitalize="off"
            type="email"
            :placeholder="$t('REGISTER_PLACEHOLDER_EMAIL')"
            class="input__field contentsquare_sensitive_data"
            v-model.trim="email">

        <!-- Validation -->
        <p class="input__message"
           v-if="errorHandler.has('email')"
           v-text="errorHandler.get('email')"/>

            <submit-button
                @click="submitCurrentStep"
                class="get-email--button"
                :processing="isFormProcessing"
                color="green">
                {{ $t('REGISTER_BUTTON_NEXT') }}
            </submit-button>
            <p class="get-email--text">{{$t('REGISTER_FLOWER_AWAIT')}}</p>
            <alt-trust-pilot step="account" class="get-email--trust-pilot"/>
            <simple-footer />
    </div>
</template>

<script>
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import EmailService from '@/services/users/EmailService';
import IncompleteRegistrationService from '@/services/users/incompleteRegistrationService/IncompleteRegistrationService';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import AltTrustPilot from '@/components/forms/fields/AltTrustPilot';
import SimpleFooter from '@/components/structure/SimpleFooter';

export default {
    name: 'GetEmail',
    data: () => {
        return {
            isFormProcessing: false,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    components: {
        SubmitButton, AltTrustPilot, SimpleFooter,
    },
    computed: {
        email: {
            get() {
                return this.$store.getters['register/getEmail'];
            },
            set(value) {
                this.$store.commit('register/setEmail', value);
            },
        },
    },
    methods: {
        onError(error) {
            this.errorHandler = error;
        },
        submitCurrentStep() {
            this.errorHandler.reset();
            this.isFormProcessing = true;
            let emailService = new EmailService();
            emailService.isEmailAvailable(this.email)
                .then(() => {
                    this.errorHandler.reset();
                    this.isFormProcessing = false;
                    setTimeout(() => (new IncompleteRegistrationService()).updateOrCreate(), 0);
                    this.$router.push({ name: 'register.subscription-details' });
                })
                .catch(error => {
                    this.isFormProcessing = false;
                    this.errorHandler.setResponse(error.response.data);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.get-email {
    display: flex;
    width: 100%;
    max-width: 440px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0px auto;

    &--text, &--heading {
        margin: 0 auto;
        margin-bottom: 40px;
        text-align: center;
        font-size: 25px;
        line-height: 30px;
    }
    &--text {
        font-size: 14px;
        width: 189px;
        line-height: 18px;
        margin-bottom: 10px;
    }
    &--button {
        width: 90%;
        min-width: 100px;
        margin: 40px 0;
    }
    &--trust-pilot {
        margin-top: 50px;
        width: 100%;
    }
}
.input__field {
    &::placeholder {
        color: #b3b3b3;
    }
}
.input__message{
    color: #b1473c;
}
</style>
